export class Key {
    protected value:any;

    constructor(value: {}) {
        this.value = value;
    }

    public Value():any{
        return this.value;
    }

    public ToString():string{
        let stringValue = "";
        for (let key in this.value) {
            if (this.value.hasOwnProperty(key)) {
                stringValue += key + ":" + this.value[key].toString() + ",";
            }
        }
        return stringValue;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/typescript-plugin/entities/Key.ts